import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog'

class NewPasswordForm extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const actions = [
      <RaisedButton label="Submit" primary={true} disabled={this.props.submitting} onClick={this.handleSubmit} />
    ];
    return (
      <Dialog open={this.props.open} title="New Password Required" onRequestClose={this.props.onRequestClose} actions={actions}>
        Your account was created by an administrator. You need to provide a new password of your choosing.
        <br />
        <TextField
          autoFocus
          ref="password"
          floatingLabelText="Password"
          type="password"
          defaultValue={this.props.password}
          onKeyDown={this.handleKeyDown}
          errorText={this.props.errors ? this.props.errors.password : null}
        />
        { this.props.error }
      </Dialog>
    )
  }

  handleSubmit = () => {
    if (this.props.onSubmit) {
      this.props.onSubmit(this.refs.password.getValue())
    }
  }

  handleKeyDown = (e, key) => {
    if (e.keyCode === 13) {
      this.handleSubmit()
    }
  }

}

NewPasswordForm.defaultProps = {
  open: true
}

export default NewPasswordForm
